import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./android.css";
import { fetchSeriesAndModel } from "../../utils/api";
import { modelImagePath } from "../../utils/constants";
import Loader from "../../components/loader/loader";

const Android = () => {
    const { slug } = useParams();

    const [city] = useState(localStorage.getItem("selectedCity") || "hyderabad");
    const [sortOption, setSortOption] = useState("lowToHigh");

    const [seriesData, setSeriesData] = useState([]);
    const [modelData, setModelData] = useState([]);
    const [brandData, setBrandData] = useState(null);

    const [loading, setLoading] = useState(true);
    const [selectedSeries, setSelectedSeries] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [price, setPrice] = useState(150000);
    const [inStock, setInStock] = useState(false);

    // ✅ API CALL
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetchSeriesAndModel(slug);

                // 🔥 Attach variants to models
                const modelsWithVariants = res.models.map(model => ({
                    ...model,
                    variants: res.variants?.filter(v => v.ItemCode == model.ItemCode) || []
                }));

                setSeriesData(res.series);
                setModelData(modelsWithVariants);
                setBrandData(res.brand);
                setLoading(false);
            } catch (err) {
                console.error(err);
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    // ✅ GET MIN PRICE
    const getMinPrice = (item) => {
        if (!item.variants || item.variants.length === 0) return 0;
        return Math.min(...item.variants.map(v => v.Rate));
    };

    // ✅ PRICE RANGE (UI)
    const getPriceRange = (item) => {
        if (!item.variants?.length) return "Price Not Available";

        const prices = item.variants.map(v => v.Rate);
        const min = Math.min(...prices);
        const max = Math.max(...prices);

        return min === max
            ? `₹${min.toLocaleString()}`
            : `₹${min.toLocaleString()} - ₹${max.toLocaleString()}`;
    };

    // ✅ CLEAR FILTERS
    const handleClearAll = () => {
        setSelectedSeries([]);
        setSearchQuery("");
        setPrice(150000);
        setInStock(false);
        setSortOption("lowToHigh");
    };

    // ✅ SERIES FILTER
    const handleSeriesChange = (code) => {
        setSelectedSeries((prev) =>
            prev.includes(code)
                ? prev.filter((c) => c !== code)
                : [...prev, code]
        );
    };

    // ✅ FILTERS
    const filteredModels = selectedSeries.length > 0
        ? modelData.filter((m) =>
            selectedSeries.includes(parseInt(m.CategoryCode))
        )
        : modelData;

    const finalModels = filteredModels
        ?.filter((m) =>
            m.ItemName.toLowerCase().includes(searchQuery.toLowerCase())
        )
        ?.filter((m) => (inStock ? m.inStock === true : true))
        ?.filter((m) => getMinPrice(m) <= price);

    // ✅ SORTING
    const sortedModels = [...(finalModels || [])].sort((a, b) => {
        const priceA = getMinPrice(a);
        const priceB = getMinPrice(b);

        if (sortOption === "lowToHigh") return priceA - priceB;
        if (sortOption === "highToLow") return priceB - priceA;
        if (sortOption === "name") return a.ItemName.localeCompare(b.ItemName);

        return 0;
    });
    return (
        <>
            {loading && <Loader />}
            <div className="container py-5">


                <div className="mb-4">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home <i className="bi bi-chevron-right me-1"></i></Link>
                            </li>

                            <li className="breadcrumb-item">
                                <Link to={`/${city?.toLowerCase()}/buy-mobile`}>
                                    Buy Mobile <i className="bi bi-chevron-right me-1"></i>
                                </Link>
                            </li>

                            <li className="breadcrumb-item active">
                                {brandData?.CategoryGroupName}
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="row">

                    {/* ===== Sidebar Filters ===== */}
                    <div className="col-lg-4 mb-4">
                        <div className="filter-box shadow-sm p-4 rounded-4 bg-white">

                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="fw-bold mb-0">Filters</h5>
                                <button
                                    className="btn btn-sm text-danger fw-semibold"
                                    onClick={handleClearAll}
                                >
                                    Clear All
                                </button>
                            </div>

                            {/* 🔍 Search */}
                            <input
                                type="text"
                                className="form-control mb-4 rounded-pill"
                                placeholder="Search model..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />

                            {/* Availability */}
                            <div className="mb-4">
                                <h6 className="filter-title">Availability</h6>
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={inStock}
                                        onChange={() => setInStock(!inStock)}
                                    />
                                    <label className="form-check-label">In Stock</label>
                                </div>
                            </div>

                            {/* Series */}
                            <div className="mb-4">
                                <h6 className="filter-title">Series</h6>

                                <h6 className="check-group__title">
                                    {brandData?.CategoryGroupName}
                                </h6>

                                {seriesData?.map((series) => (
                                    <label
                                        htmlFor={series?.cc_slug}
                                        className="checkbox"
                                        key={series?.cc_slug}
                                    >
                                        <input
                                            className="checkbox__input"
                                            type="checkbox"
                                            id={series?.cc_slug}
                                            value={series.cc_slug}
                                            checked={selectedSeries.includes(series.CategoryCode)}
                                            onChange={() => handleSeriesChange(series.CategoryCode)}
                                        />

                                        <svg
                                            className="checkbox__icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 22 22"
                                        >
                                            <rect
                                                width="21"
                                                height="21"
                                                x=".5"
                                                y=".5"
                                                fill="#FFF"
                                                stroke="#006F94"
                                                rx="3"
                                            />
                                            <path
                                                className="tick"
                                                stroke="#6EA340"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeWidth="4"
                                                d="M4 10l5 5 9-9"
                                            />
                                        </svg>

                                        <span className="checkbox__label">
                                            {series?.CategoryName}
                                        </span>
                                    </label>
                                ))}

                            </div>

                            {/* Price */}
                            <div>
                                <h6>Max Price</h6>
                                <input
                                    type="range"
                                    min="0"
                                    max="150000"
                                    step="5000"
                                    value={price}
                                    onChange={(e) => setPrice(Number(e.target.value))}
                                    style={{ width: "100%" }} />
                                <div>₹ {price}</div>
                            </div>

                        </div>
                    </div>

                    {/* ===== Products ===== */}
                    <div className="col-lg-8">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="fw-bold">
                                {brandData?.CategoryGroupName} Models
                            </h5>

                            <select
                                className="form-select w-auto"
                                value={sortOption}
                                onChange={(e) => setSortOption(e.target.value)}
                            >
                                <option value="">Sort By</option>
                                <option value="lowToHigh">Price: Low to High</option>
                                <option value="highToLow">Price: High to Low</option>
                                <option value="name">Name (A-Z)</option>
                            </select>
                        </div>


                        <div className="row g-4">

                            {sortedModels?.map((item) => (
                                <div key={item.ItemCode} className="col-md-6">

                                    <div className="card shadow-sm border-0 rounded-4 h-100">

                                        <div className="row g-0 align-items-center h-100">

                                            {/* Image */}
                                            <div className="col-5 bg-light text-center p-3">
                                                <img
                                                    src={modelImagePath + item.ic_slug + ".webp"}
                                                    alt={item.ItemName}
                                                    style={{ height: "140px", objectFit: "contain" }}
                                                />
                                            </div>

                                            {/* Content */}
                                            <div className="col-7">
                                                <div className="card-body">

                                                    <h6 className="fw-bold">
                                                        {item.ItemName}
                                                    </h6>

                                                    <p className="text-muted small">
                                                        Sell your phone instantly at best price
                                                    </p>
                                                    <h6 className="text-success fw-bold mb-2">
                                                        ₹{getMinPrice(item).toLocaleString()}                                                    </h6>
                                                    <Link
                                                        to={`/${city?.toLowerCase()}/buy-mobile/${item.cgc_slug}/${item.ic_slug}`}
                                                        className="btn btn-primary btn-sm rounded-pill px-3 fw-semibold"
                                                    >
                                                        Proceed
                                                    </Link>

                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            ))}

                            {finalModels?.length === 0 && (
                                <h6>No Models Found</h6>
                            )}

                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default Android;